import { render, staticRenderFns } from "./Bidders.vue?vue&type=template&id=10411eac&"
import script from "./Bidders.vue?vue&type=script&lang=js&"
export * from "./Bidders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports